import React from "react"
import { Workbox } from "workbox-window"
import { toast } from "react-toastify"
import UpdatePrompt from "./components/UpdatePrompt"
import { waitForSync } from "./services/sync.service"

// ── IL SERVICE WORKER ──────────────────────────────────────────────
// È lui che fa aprire l'app senza rete (vedi `service-worker.js`). Il
// prezzo è che l'app non si aggiorna più da sola: chi la apre si vede
// servire la versione che ha già sul telefono, e quella nuova arriva in
// sottofondo. Quando è pronta lo si dice, e si aggiorna quando lo decide
// chi la sta usando — non a metà di una lezione.
//
// Solo nella build: in sviluppo il service worker non c'è, e una copia in
// cache dell'app in sviluppo sarebbe solo d'intralcio.

// Un'app installata sul telefono può restare aperta per giorni senza mai
// ricaricarsi: senza chiederlo, una versione nuova non la vedrebbe mai.
// Si chiede quando l'app torna in primo piano, e ogni ora mentre ci resta.
const UPDATE_CHECK_INTERVAL = 60 * 60 * 1000
const MIN_UPDATE_CHECK_GAP = 5 * 60 * 1000

// Prima di ricaricare si aspetta che quello che è da inviare sia partito,
// ma non per sempre: le scritture in coda sopravvivono comunque al
// ricaricamento, sono le operazioni a metà a non farlo.
const SYNC_BEFORE_RELOAD_TIMEOUT = 5000

const showUpdatePrompt = wb => {
	const applyUpdate = async () => {
		await waitForSync(SYNC_BEFORE_RELOAD_TIMEOUT)

		// Ricarica solo la scheda che l'ha chiesto, e solo quando la
		// versione nuova ha preso il posto della vecchia: prima, la pagina
		// ricaricata arriverebbe ancora da quella vecchia.
		wb.addEventListener("controlling", () => window.location.reload())
		wb.messageSkipWaiting()
	}

	toast(<UpdatePrompt onUpdate={applyUpdate} />, {
		toastId: "app-update",
		position: "top-center",
		autoClose: false,
		closeOnClick: false,
		draggable: false,
	})
}

export const registerServiceWorker = () => {
	if (process.env.NODE_ENV !== "production") return
	if (!("serviceWorker" in navigator)) return

	// Il service worker deve stare sullo stesso indirizzo della pagina:
	// con PUBLIC_URL su un altro dominio non potrebbe funzionare.
	const publicURL = new URL(process.env.PUBLIC_URL, window.location.href)
	if (publicURL.origin !== window.location.origin) return

	const wb = new Workbox(`${process.env.PUBLIC_URL}/service-worker.js`)

	// Anche all'apertura, se una versione nuova era già scaricata e in
	// attesa dall'ultima volta.
	wb.addEventListener("waiting", () => showUpdatePrompt(wb))

	let lastCheck = Date.now()
	const checkForUpdate = () => {
		if (navigator.onLine === false) return
		if (Date.now() - lastCheck < MIN_UPDATE_CHECK_GAP) return
		lastCheck = Date.now()
		wb.update().catch(err => console.info("Controllo aggiornamenti non riuscito:", err))
	}

	wb.register()
		.then(() => {
			document.addEventListener("visibilitychange", () => {
				if (document.visibilityState === "visible") checkForUpdate()
			})
			setInterval(checkForUpdate, UPDATE_CHECK_INTERVAL)
		})
		.catch(err => console.error("Service worker non registrato:", err))
}
